/**
 * 코드 분할된 라우트 청크를 불러오는 동안 보여주는 Suspense fallback.
 * RequireAuth 의 로딩 표시와 같은 skeleton 스타일을 사용해 일관성 유지.
 * - full: 공개 페이지(전체 화면). 기본은 AppShell 콘텐츠 영역용(부분 높이).
 */
export function RouteFallback({ full = false }: { full?: boolean }) {
  return (
    <div
      className={`grid ${full ? 'min-h-dvh' : 'min-h-[40vh]'} place-items-center`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="skeleton h-10 w-40" />
      <span className="sr-only">화면을 불러오는 중…</span>
    </div>
  );
}
